import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ErrorType } from "@/shared/types"
import { IBusinessCardDetailsState } from "./types"
import { fetchBusinessCard, fetchBusinessCardTransactions } from "./business-card-details-thunk"

const initialState: IBusinessCardDetailsState = {
    card: null,
    transactions: [],
    transactionDetails: null,
    isLoading: false,
    isFirstLoad: true,
    error: null,
    page: 1,
    totalPages: 1
}

const businessCardDetailsSlice = createSlice({
    name: 'businessCardDetails',
    initialState,
    reducers: {
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload
        },
        resetState: (state) => {
            state.card = null
            state.transactions = []
            state.transactionDetails = null
            state.isFirstLoad = true
            state.page = 1
            state.error = null
        }
    },
    extraReducers(builder) {
        builder
            // Fetch card
            .addCase(fetchBusinessCard.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchBusinessCard.fulfilled, (state, action) => {
                state.isLoading = false
                state.card = action.payload
                state.error = null
            })
            .addCase(fetchBusinessCard.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload as ErrorType ?? null
            })
            // Fetch transactions
            .addCase(fetchBusinessCardTransactions.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchBusinessCardTransactions.fulfilled, (state, action) => {
                state.isLoading = false
                state.isFirstLoad = false
                state.transactions = action.payload.items
                state.transactionDetails = action.payload.aggregate
                state.totalPages = action.payload.totalPages
                state.error = null
            })
            .addCase(fetchBusinessCardTransactions.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload as ErrorType ?? null
            })
    },
})

export const { setPage, resetState } = businessCardDetailsSlice.actions
export default businessCardDetailsSlice.reducer

